module.exports = __webpack_public_path__ + "img/951206867ba37266203b7136b50ea3d0.svg";